import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const MenuContainer = styled.div`
  position: relative;
  &>div:first-child{
    top: ${props => (props.topPosition ? -props.topPosition + "px" : "0")};
    left: ${props => (props.leftPosition ? -props.leftPosition + "px" : "0")};
  }
	.menu-container-wrapper {
	    cursor: auto;
		z-index: 999;
		position: absolute;
      ${props => {
        if (props.openTowardUp) {
          return `bottom: ${props.bottomPosition ? props.bottomPosition + "px" : "-16px"}`;
        } else {
          return `top: ${props.topPosition ? props.topPosition + "px" : "4px"};`;
        }
      }};
		left: ${props => (props.leftPosition ? props.leftPosition + "px" : "16px")};
    /* min-height: ${props => (props.isSmall ? "" : "564px")}; */
    /* max-height: ${props => (props.isSmall ? "" : "564px")}; */
        min-width: ${props =>
          props.isLarge ? "372px" : props.isSmall ? "200px" : "300px"} ;
        max-width: ${props =>
          props.isLarge ? "372px" : props.isSmall ? "200px" : "300px"};
            background-color: ${props =>
              props.isLarge
                ? Variables.colors.complementary
                : Variables.colors.complementary_light};
            border-radius: 4px;
            -webkit-box-shadow: 0 2px 8px 1px #CCCCCC;
            -moz-box-shadow: 0 2px 8px 1px #CCCCCC;
            box-shadow: 0 2px 8px 1px #CCCCCC;
	}
`;
